import Component from '../../../assets/scripts/modules/component'
import insertScript from '../../../assets/scripts/utilities/insert-script-async'
import randomHash from '../../../assets/scripts/utilities/random-hash'

export default class HubspotEmbedComponent extends Component {
  init () {
    this.codeContainer = this.element.querySelector('.hubspot-embed__code-container')
    this.formContainer = this.element.querySelector('.hubspot-embed__form-container')

    this.hubspotRegion = this.element.getAttribute('data-hubspot-region') || ''
    this.hubspotPortalId = this.element.getAttribute('data-hubspot-portal-id') || ''
    this.hubspotFormId = this.element.getAttribute('data-hubspot-form-id') || ''

    if (!this.codeContainer || !this.formContainer || !this.hubspotRegion || !this.hubspotPortalId || !this.hubspotFormId) {
      return
    }

    this.hash = randomHash()
    this.initExternalScript()
  }

  async initExternalScript () {
    await insertScript(`hubspot-script-${this.hash}`, `//js-${this.hubspotRegion}.hsforms.net/forms/embed/v2.js`, this.codeContainer)

    if (!window.hbspt) {
      return
    }

    this.formContainer.classList.add(`hubspot-form--${this.hash}`) // Hubspot doesn't recognize id selector
    window.hbspt.forms.create({ region: this.hubspotRegion, portalId: this.hubspotPortalId, formId: this.hubspotFormId, target: `.hubspot-form--${this.hash}` })
  }
}

window.addEventListener('init-delayed-load', () => [...document.querySelectorAll('.hubspot-embed')].forEach(element => {
  element.instance = element.instance || new HubspotEmbedComponent(element)
}))
